import { shallowEqual, useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import {
  selectAverageEngagementPercent,
  selectAverageImpressions,
  selectAverageReach,
  selectBrandFanMember,
  selectCollabsCount,
  selectFollowersCount,
} from '@store/brandFans'

export const useBrandFanInfluencerIdentityPerformance = (params: {
  identityId: number
  brandFanMemberId?: number
  brandFanGroupId?: number
}) =>
  useSelector((state: IApplicationState) => {
    const { identityId, brandFanGroupId, brandFanMemberId } = params
    if (brandFanGroupId && brandFanMemberId) {
      const brandFanMember = selectBrandFanMember(state, brandFanGroupId, brandFanMemberId)
      return {
        followerCount: brandFanMember.identity_followers_count,
        averageEngagementPercent: brandFanMember.identity_analytics?.avg_engagement_pct,
        averageImpressions: brandFanMember.identity_analytics?.avg_impressions,
        collabs: brandFanMember.identity_collabs,
        averageReach: brandFanMember.identity_analytics?.avg_reach_pct,
      }
    }
    return {
      followerCount: selectFollowersCount(state, identityId),
      averageEngagementPercent: selectAverageEngagementPercent(state, identityId),
      averageImpressions: selectAverageImpressions(state, identityId),
      collabs: selectCollabsCount(state, identityId),
      averageReach: selectAverageReach(state, identityId),
    }
  }, shallowEqual)
